import styled, {css} from 'styled-components';

import {IconButton} from '../../../libs/shared/ui/src/components/buttons/iconButton';
import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis, flexCenter} from '../../../libs/shared/ui/src/styles/mixins';

const baseStyle = css`
  height: 40px;

  border-bottom: 1px solid ${(p) => p.theme.greys.shade30};
  border-right: 1px solid ${(p) => p.theme.greys.shade30};

  :first-child {
    border-left: none;
  }

  :last-child {
    border-right: none;
  }

  ${ellipsis()}
`;

export const StyledDataFieldsTableCell = styled.td`
  ${baseStyle};

  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.medium};
  padding: 7px;
`;

export const StyledDataFieldsTableHeader = styled.th`
  ${baseStyle};
  background-color: ${(p) => p.theme.greys.white};
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.semibold};
  border-top: 1px solid ${(p) => p.theme.greys.shade30};
`;

export const StyledRemoveRowButton = styled(IconButton)``;

export const StyledDataFieldsTableRow = styled.div`
  ${flexCenter};

  & ${StyledRemoveRowButton} {
    visibility: hidden;
  }

  &:hover ${StyledRemoveRowButton} {
    visibility: visible;
  }
`;
